// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post } from "@insite/client-framework/Services/ApiService";
import {
    GetProductCollectionRealTimeInventoryApiV2Parameter,
    GetProductRealTimeInventoryApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

const realTimeInventoryUrl = "/api/v1/realtimeinventory";

// XNG-CHANGES-GSS-480 : Adding properties to getProductRealTimeInventory and getProductCollectionRealTimeInventory
export async function getProductRealTimeInventory(
    parameter: GetProductRealTimeInventoryApiV2Parameter & { properties?: any },
) {
    const realTimeInventoryModel = await getProductCollectionRealTimeInventory({
        expand: parameter.expand,
        productIds: [parameter.productId],
        additionalQueryStringParameters: parameter.additionalQueryStringParameters,
        configurations: parameter.configuration ? { [parameter.productId]: parameter.configuration } : undefined,
        properties: parameter.properties,
    } as any);

    return realTimeInventoryModel.realTimeInventoryResults?.find(o => o.productId === parameter.productId);
}

export function getProductCollectionRealTimeInventory(
    parameter: GetProductCollectionRealTimeInventoryApiV2Parameter & { properties?: any },
) {
    let url = realTimeInventoryUrl;
    if (parameter.expand) {
        url += `?expand=${parameter.expand.join(",")}`;
    }
    return post<GetProductCollectionRealTimeInventoryApiV2Parameter, RealTimeInventoryModel>(`${url}`, {
        productIds: parameter.productIds,
        configurations: parameter.configurations,
        properties: parameter.properties,
    } as any);
}
